import { formatValueToBNString } from "configs/web3";

export const formatAmount = <T extends { amount?: string }>(data: T) => {
  const amount = data && data.amount ? formatValueToBNString(data.amount) : undefined;
  return { ...data, amount };
};
